import type {
  GeneratedLesson,
  LessonPlanSection as LessonPlanSectionType,
} from "../types";
import { BookMarked } from "lucide-react";

interface LessonPlanSectionProps {
  lesson: GeneratedLesson;
}

export function LessonPlanSection({ lesson }: LessonPlanSectionProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-4">
        <BookMarked
          className="w-5 h-5"
          style={{ color: "var(--primary-color)" }}
        />
        <h3
          className="text-xl font-bold"
          style={{ color: "var(--text-primary)" }}
        >
          Plano de Aula
        </h3>
      </div>

      <div className="space-y-4">
        {Object.values(lesson.lessonPlan).map(
          (section: LessonPlanSectionType, idx: number) => (
            <div
              key={idx}
              className="border-l-4 pl-4"
              style={{ borderColor: "var(--primary-color)" }}
            >
              <h4
                className="font-bold mb-2"
                style={{ color: "var(--text-primary)" }}
              >
                {section.title}
              </h4>
              <p style={{ color: "var(--text-secondary)" }}>
                {section.description}
              </p>
              {section.activities && section.activities.length > 0 && (
                <ul className="mt-2 ml-4 space-y-1">
                  {section.activities.map(
                    (activity: string, actIdx: number) => (
                      <li
                        key={actIdx}
                        className="text-sm"
                        style={{ color: "var(--text-tertiary)" }}
                      >
                        • {activity}
                      </li>
                    ),
                  )}
                </ul>
              )}
            </div>
          ),
        )}
      </div>
    </div>
  );
}
